import React, { useEffect, useRef, useState } from "react";
import { Link, Route, Routes } from "react-router-dom";
import Dashboard from "./Dashboard";
import { Homepage } from "../../frontend/pages/Homepage";
import { HeaderSticky as BootstrapHeaderSticky } from "bootstrap-italia";
import logo from "../../assets/images/logosalerno.png";
import icons from "bootstrap-italia/dist/svg/sprites.svg";
import AuthUser from "./AuthUser";
import Servizio from "../../frontend/pages/Servizio";
import User from "./User";
import LoginSso from "./LoginSso";
import LogoutPage from "./logoutPage";
import ProfilePage from "./ProfilePage";
import Footer from "../../frontend/components/footer/Footer";
import CreaUfficio from "../../frontend/pages/CreaUfficio";
import LoginForm from "./LoginForm";
import { LAYOUT_URL } from "../../server";

const Auth = () => {
  const { token, logout } = AuthUser();
  const [isMobile, setIsMobile] = useState(
    sessionStorage.getItem("mobile") || false
  );
  const headerRef = useRef(null);

  // 👇 NUOVO: stato per i menu dell'header
  const [headerMenus, setHeaderMenus] = useState(null);

  useEffect(() => {
    // attiva sticky sull'header una sola volta (utile in SPA)
    if (!headerRef.current) return;
    let instance;
    try {
      instance = new BootstrapHeaderSticky(headerRef.current);
    } catch (_) {
      // se già inizializzato via data-API, ignora
    }
    return () => {
      if (instance && typeof instance.dispose === "function")
        instance.dispose();
    };
  }, []);

  useEffect(() => {
    const url = new URL(window.location.href);
    const mobile = new URLSearchParams(url.search).get("mobile");
    if (mobile === "true") {
      setIsMobile(true);
      sessionStorage.setItem("mobile", true);
    }
  }, []);

  // 👇 NUOVO: fetch dei menu header
  useEffect(() => {
    fetch(`${LAYOUT_URL}header-menus`)
      .then((res) => res.json())
      .then((data) => {
        setHeaderMenus(data);
      })
      .catch((err) => {
        console.error("Errore caricando header-menus", err);
      });
  }, []);

  const user = JSON.parse(sessionStorage.getItem("user"));
  const logoutUser = () => {
    if (!token !== undefined) logout();
  };

  // Helpers per i menu dinamici
  const sortByWeight = (a, b) =>
    Number(a?.weight ?? 0) - Number(b?.weight ?? 0);

  const topLeft = headerMenus?.topleft;
  const topRight = headerMenus?.topright;
  const social = headerMenus?.social;

  const renderTopLeftMenu = () => {
    if (topLeft?.items?.length) {
      return topLeft.items.sort(sortByWeight).map((item) => {
        const href = item.url || "#";
        const isExternal = item.external;
        return (
          <li className="nav-item" key={`${item.title}-${href}`}>
            <a
              className="nav-link"
              href={href}
              aria-disabled="true"
              data-focus-mouse="false"
              target={isExternal ? "_blank" : undefined}
              rel={isExternal ? "noreferrer" : undefined}
            >
              <span>{item.title}</span>
            </a>
          </li>
        );
      });
    }

    // fallback hardcodato (il tuo attuale)
    return (
      <>
        <li className="nav-item">
          <a
            className="nav-link"
            href={`/amministrazione`}
            aria-disabled="true"
            data-focus-mouse="false"
          >
            <span>Amministrazione</span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href={`/novita`} aria-disabled="true">
            <span>Novità</span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href={`/servizi`} aria-disabled="true">
            <span>Servizi</span>
          </a>
        </li>
        <li className="nav-item">
          <a
            className="nav-link"
            href={`/vivere-il-comune`}
            aria-disabled="true"
          >
            <span>Vivere il Comune</span>
          </a>
        </li>
      </>
    );
  };

  const renderTopRightMenu = () => {
    if (topRight?.items?.length) {
      return topRight.items.sort(sortByWeight).map((item) => {
        const href = item.url || "#";
        const isExternal = item.external;
        return (
          <li className="nav-item" key={`${item.title}-${href}`}>
            <a
              className="nav-link"
              href={href}
              data-focus-mouse="false"
              target={isExternal ? "_blank" : undefined}
              rel={isExternal ? "noreferrer" : undefined}
            >
              {/* qui il titolo arriva già "Tutti gli argomenti..." ecc */}
              {item.title === "Tutti gli argomenti..." ? (
                <span className="fw-bold">{item.title}</span>
              ) : (
                item.title
              )}
            </a>
          </li>
        );
      });
    }

    // fallback hardcodato
    return (
      <>
        <li className="nav-item">
          <a
            className="nav-link"
            href={`/tutti-gli-argomenti/elezioni-regionali-2025`}
            data-focus-mouse="false"
          >
            Regionali 2025
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href={`/tutti-gli-argomenti/pnrr`}>
            PNRR
          </a>
        </li>
        <li className="nav-item">
          <a
            className="nav-link"
            href={`/tutti-gli-argomenti/`}
            data-element="all-topics"
          >
            <span className="fw-bold">Tutti gli argomenti...</span>
          </a>
        </li>
      </>
    );
  };

  const getSocialIconId = (url) => {
    if (!url) return "it-link";
    const lower = url.toLowerCase();
    if (lower.includes("facebook")) return "it-facebook";
    if (lower.includes("youtube")) return "it-youtube";
    return "it-link";
  };

  const socialItems =
    social?.items && social.items.length
      ? social.items
      : [
          {
            url: "https://it-it.facebook.com/ComuneSalerno",
            title: "Facebook",
          },
          {
            url: "https://www.youtube.com/user/CittadiSalerno",
            title: "YouTube",
          },
        ];

  return (
    <div
      style={{
        // backgroundColor: "red",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {!isMobile && (
        <header
          ref={headerRef}
          className="it-header-wrapper it-header-sticky"
          data-bs-toggle="sticky"
          data-bs-position-type="fixed"
          data-bs-sticky-class-name="is-sticky"
          data-bs-target="#header-nav-wrapper"
        >
          <div className="it-header-slim-wrapper">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="it-header-slim-wrapper-content">
                    <a
                      className="d-lg-block navbar-brand"
                      target="_blank"
                      href="https://www.regione.campania.it/"
                      aria-label="Vai al portale Regione Campania - link esterno - apertura nuova scheda"
                      title="Vai al portale Regione Campania"
                      rel="noreferrer"
                    >
                      Regione Campania
                    </a>
                    <div className="it-header-slim-right-zone d-flex justify-content-end">
                      {/* qui puoi riattivare il login area se serve */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="it-nav-wrapper">
            <div className="it-header-center-wrapper">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="it-header-center-content-wrapper">
                      <div className="it-brand-wrapper">
                        <a className="dropdown-item list-item" href={`/`}>
                          <img
                            className="brand-logo"
                            style={{
                              width: "150px",
                              height: "auto",
                              marginRight: "16px",
                            }}
                            aria-hidden="true"
                            src={logo}
                            alt="logo"
                          />
                          <div className="it-brand-text">
                            <div className="it-brand-title brand-title">
                              Comune di Salerno
                            </div>
                            <div
                              className="it-brand-subtitle brand-subtitle"
                              style={{
                                fontSize: "17px",
                                fontWeight: "400",
                              }}
                            >
                              Hippocratica Civitas
                            </div>
                          </div>
                        </a>
                      </div>
                      <div className="it-right-zone">
                        <div className="it-socials d-none d-md-flex">
                          <span>{social?.label || "Seguici su"}</span>
                          <ul>
                            {socialItems.map((item, idx) => (
                              <li key={`${item.url}-${idx}`}>
                                <a
                                  href={item.url}
                                  aria-label={item.title || "Social"}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <svg className="icon">
                                    <use
                                      href={`${icons}#${getSocialIconId(
                                        item.url
                                      )}`}
                                    />
                                  </svg>
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/* /.it-header-center-content-wrapper */}
                  </div>
                </div>
              </div>
            </div>

            {/* trigger dello sticky */}
            <div className="it-header-navbar-wrapper" id="header-nav-wrapper">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <nav
                      className="navbar navbar-expand-lg has-megamenu"
                      aria-label="Navigazione principale"
                      style={{
                        paddingLeft: "0px",
                        paddingRight: "0px",
                      }}
                    >
                      <button
                        className="custom-navbar-toggler"
                        type="button"
                        aria-controls="navC1"
                        aria-expanded="false"
                        aria-label="Mostra/Nascondi la navigazione"
                        data-bs-toggle="navbarcollapsible"
                        data-bs-target="#navC1"
                      >
                        <svg className="icon">
                          <use href={`${icons}#it-burger`} />
                        </svg>
                      </button>

                      <div className="navbar-collapsable" id="navC1">
                        <div className="overlay"></div>
                        <div className="close-div">
                          <button className="btn close-menu" type="button">
                            <span className="visually-hidden">
                              Nascondi la navigazione
                            </span>
                            <svg className="icon">
                              <use href={`${icons}#it-close-big`} />
                            </svg>
                          </button>
                        </div>
                        <div className="menu-wrapper">
                          <ul className="navbar-nav">{renderTopLeftMenu()}</ul>
                        </div>
                      </div>

                      <div className="navbar-collapsable text-right" id="navC2">
                        <div className="overlay"></div>
                        <div className="close-div">
                          <button className="btn close-menu" type="button">
                            <span className="visually-hidden">
                              Nascondi la navigazione
                            </span>
                            <svg className="icon">
                              <use href={`${icons}#it-close-big`} />
                            </svg>
                          </button>
                        </div>
                        <div className="menu-wrapper justify-content-end">
                          <ul
                            id="menu-argomenti"
                            className="navbar-nav navbar-secondary"
                          >
                            {renderTopRightMenu()}
                          </ul>
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /.it-nav-wrapper */}
        </header>
      )}

      <Routes>
        <Route path="/prenotazione-appuntamento/" element={<Homepage />} />
        <Route
          path="/prenotazione-appuntamento/servizio"
          element={<Servizio />}
        />
        <Route
          path="/prenotazione-appuntamento/dashboard"
          element={<Dashboard />}
        />
        <Route path="/prenotazione-appuntamento/user" element={<User />} />
        <Route path="/prenotazione-appuntamento/sso" element={<LoginSso />} />
        <Route
          path="/prenotazione-appuntamento/logout"
          element={<LogoutPage />}
        />
        <Route
          path="/prenotazione-appuntamento/login"
          element={<LoginForm />}
        />
        <Route
          path="/prenotazione-appuntamento/profile"
          element={<ProfilePage />}
        />
        <Route
          path="/prenotazione-appuntamento/crea-ufficio"
          element={<CreaUfficio />}
        />
      </Routes>

      {!isMobile && <Footer />}
    </div>
  );
};

export default Auth;
